import React, { useContext, useState } from "react";
import { useSelector } from "react-redux";
import ChatContext from "./ChatContext";
import Icon from "components/common_components/Icon";

function MessageSender() {
    const { selectedConversation } = useContext(ChatContext);
    const { user } = useSelector((state) => state.Login);
    const [newMessage, setNewMessage] = useState("");

    const onNewMessageChange = (event) => {
        setNewMessage(event.target.value);
    };

    const sendMessage = (event) => {
        event.preventDefault();
        if (newMessage && typeof newMessage === "string" && newMessage.trim().length > 0) {
            selectedConversation.sendMessage(newMessage, {
                senderUserEmail: user.email
            });
            setNewMessage("");
        }
    };

    const onInputKeyDown = (event) => {
        if (event.key === "Enter") {
            sendMessage(event);
        }
    };

    if (selectedConversation.state.current !== "active") {
        return <p className="non-active">This conversation is {selectedConversation.state.current}!</p>;
    }

    return (
        <>
            <input
                type="text"
                className="write-message"
                value={newMessage}
                onChange={onNewMessageChange}
                onKeyDown={onInputKeyDown}
                placeholder="Type your message here"
            />
            <button className="send clickable">
                <Icon name="paper-plane" color="white" size="md" onClick={sendMessage} aria-hidden="true" />
            </button>
        </>
    );
}

export default MessageSender;